// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"562":"800b779462fcfe51","8946":"18e7aa7a61939fa1"}[chunkId] + ".css";
};